import { Box, Heading, Page, TextButton } from '@zillow/constellation-10';
import { IconChevronLeftFilled } from '@zillow/constellation-icons';
import Layout from '../Layout';
import PageHeading from '../PageHeading';
import LeadManagementTableSkeleton from '../LeadManagementTable/Skeleton';
import LeadManagementCardsSkeleton from '../LeadManagementCards/Skeleton';
import { leadManagementHeaderStyles } from '../../styles/leadManagementStyles';
import { LeadManagementConversationSearchBarSkeleton } from '../SearchBar/Skeleton';

export default function LeadManagementPageSkeleton() {
  return (
    <Layout>
      <Page.Content>
        <TextButton icon={<IconChevronLeftFilled />} disabled={true}>
          Back to
        </TextButton>
        <Box css={{ marginTop: 'loose', marginBottom: 'loose' }}>
          <PageHeading heading="Leads" />
        </Box>
        <Box css={leadManagementHeaderStyles}>
          <Heading level={2} css={{ textStyle: { xlDown: 'h6', xl: 'h4' }, marginRight: 'auto' }}>
            Leads
          </Heading>
          <LeadManagementConversationSearchBarSkeleton />
        </Box>

        <Box css={{ xlDown: { display: 'none' } }}>
          <LeadManagementTableSkeleton />
        </Box>

        <Box css={{ xl: { display: 'none' } }}>
          <LeadManagementCardsSkeleton />
        </Box>
      </Page.Content>
    </Layout>
  );
}
